import { type ReactNode, createContext, useContext } from "react"

const RouteOverlayContext = createContext(false)

export function RouteOverlayProvider({ children, overlay }: { children: ReactNode; overlay: ReactNode }) {
    return (
        <RouteOverlayContext.Provider value={overlay !== null}>
            {children}
            {overlay}
        </RouteOverlayContext.Provider>
    )
}

export function useRouteOverlayActive(): boolean {
    return useContext(RouteOverlayContext)
}
